import script from "./sources.vue?vue&type=script&setup=true&lang=js"
export * from "./sources.vue?vue&type=script&setup=true&lang=js"

import "./sources.vue?vue&type=style&index=0&id=28beffd9&lang=scss"

const __exports__ = script;

export default __exports__